import { PreviewType } from 'js/file_viewer/core/types/preview_type';
const getCloudDocExitUrl = (previewMetadata) => {
    var _a, _b;
    const previewType = previewMetadata === null || previewMetadata === void 0 ? void 0 : previewMetadata.previewType;
    if ((previewType === PreviewType.SsrDoc || previewType === PreviewType.CloudDoc) &&
        ((_a = previewMetadata === null || previewMetadata === void 0 ? void 0 : previewMetadata.content) === null || _a === void 0 ? void 0 : _a['.tag']) === 'cloud_doc' &&
        ((_b = previewMetadata === null || previewMetadata === void 0 ? void 0 : previewMetadata.content) === null || _b === void 0 ? void 0 : _b.exit_url)) {
        return previewMetadata.content.exit_url;
    }
    return undefined;
};
export const getWillCloudDocPreviewAsSsrDoc = (featureConfig, previewMetadata) => {
    return (((previewMetadata === null || previewMetadata === void 0 ? void 0 : previewMetadata.previewType) === PreviewType.CloudDoc ||
        (previewMetadata === null || previewMetadata === void 0 ? void 0 : previewMetadata.previewType) === PreviewType.SsrDoc) &&
        (featureConfig.cloud_doc_preview_mode === 'preview' || !getCloudDocExitUrl(previewMetadata)));
};
//# sourceMappingURL=cloud_docs.preenvesnextjs.map
